import { render, staticRenderFns } from "./addRelationModal.vue?vue&type=template&id=2c4a00ed&scoped=true&"
import script from "./addRelationModal.vue?vue&type=script&lang=js&"
export * from "./addRelationModal.vue?vue&type=script&lang=js&"
import style0 from "./addRelationModal.vue?vue&type=style&index=0&id=2c4a00ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a00ed",
  null
  
)

export default component.exports